// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import {
  type CompetitorInfo,
  type CompetitorInfoWireFormat,
  NewCompetitorInfo,
} from '../CompetitorInfo/CompetitorInfo';
import {
  NewProjectCompetitorProduct,
  type ProjectCompetitorProduct,
  type ProjectCompetitorProductWireFormat,
} from '../ProjectCompetitorProduct/ProjectCompetitorProduct';
import {
  NewProjectLossReason,
  ProjectLossReason,
  type ProjectLossReasonWireFormat,
} from '../ProjectLossReason/ProjectLossReason';

export class ProjectCompetitor {
  readonly id: string;
  readonly products: ProjectCompetitorProduct[];
  readonly competitor: CompetitorInfo | null;
  readonly lossReason: ProjectLossReason;
  readonly lossReasonNotes: string | null;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.products = (data.products ?? []).map((products: any) =>
      NewProjectCompetitorProduct(products),
    );
    this.competitor =
      // eslint-disable-next-line no-nested-ternary
      (data.competitor ?? null) === null ? null : NewCompetitorInfo(data.competitor);
    this.lossReason = NewProjectLossReason(data.lossReason);
    this.lossReasonNotes = data.lossReasonNotes === undefined ? null : data.lossReasonNotes;
  }

  static zero(): ProjectCompetitor {
    const zeroValues: ExcludeMethodsDeep<ProjectCompetitor> = {
      id: NIL_UUID,
      products: [],
      competitor: null,
      lossReason: ProjectLossReason.zero(),
      lossReasonNotes: null,
    };
    return new ProjectCompetitor(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ProjectCompetitorWireFormat = {
  id: string;
  products: ProjectCompetitorProductWireFormat[];
  competitor: CompetitorInfoWireFormat | null;
  lossReason: ProjectLossReasonWireFormat;
  lossReasonNotes: string | null;
};

type NewProjectCompetitorProps = PartialDeep<ProjectCompetitor, { recurseIntoArrays: true }>;
export const NewProjectCompetitor: (props: NewProjectCompetitorProps) => ProjectCompetitor = (
  props,
) => new ProjectCompetitor(props);

type NewProjectCompetitorFromWireFormatProps = PartialDeep<
  ProjectCompetitorWireFormat,
  { recurseIntoArrays: true }
>;
export const NewProjectCompetitorFromWireFormat: (
  props: NewProjectCompetitorFromWireFormatProps,
) => ProjectCompetitor = (props) => new ProjectCompetitor(props);
